import React from 'react';
import styled from 'styled-components';
import Column from '../../column';
import ButtonHighlights from './buttons';
import BlockHighlights from './blocks';

const getComponent = (variant) => {
  switch (variant) {
    case 'blocks':
      return BlockHighlights;
    case 'buttons':
    default:
      return ButtonHighlights;
  }
};

const Highlights = ({
  // id,
  highlights,
  variant,
  offset,
}) => {
  if ((highlights || []).length === 0) {
    return null;
  }
  const Component = getComponent(variant);
  return (
    <Column justify="center" offset={offset}>
      <Component
        variant={variant}
        highlights={highlights}
      />
    </Column>
  );
};

export default styled(Highlights)``;
